<template>
  <div>
    <div class="campaign-bar bg-light shadow-sm border-bottom pt-2 pb-2">
      <b-row class="m-0">
        <b-col xl="5" xxl="4" lg="6" sm="12" md="12">
          <b-form inline>
            <label class="mr-2 d-none d-xl-inline" for="inlineFormInputCampaign">
              <font-awesome-icon :icon="['fas', 'globe']" class="mr-2" /><strong>Campaign:</strong>
            </label>
            <b-dropdown id="dropdown-grouped" :text="menuCampaignSelected" variant="default" class="campaign-dropdown">
              <b-dropdown-group v-for="(group, index) in menuCampaigns" :key="'dropdown-group-' + group.id" :header="group.label" :class="'header-' + group.id">
                <b-dropdown-item-button v-for="campaign in group.campaigns" @click="select_campaign(campaign.id)" :key="campaign.id">
                  <div class="mt-1">
                    <strong>{{ campaign.name }}</strong> <span v-if="campaign.cruise !== ''" class="text-muted">({{ campaign.cruise }})</span>
                    <div class="text-muted">
                      <small>{{ campaign.description }}</small>
                    </div>
                  </div>
                  <div class="mb-1">
                    <small>
                      <font-awesome-icon :icon="['far', 'calendar-alt']" class="mr-1" />
                      <span v-if="campaignType(campaign.id) === 1">
                      Started on <strong><span class="text-success">{{ datetime_start(campaign.id) }}</span></strong>
                    </span>
                      <span v-else-if="campaignType(campaign.id) === 2">
                      Starting on <strong><span class="text-primary">{{ datetime_start(campaign.id) }}</span></strong>
                    </span>
                      <span v-else-if="campaignType(campaign.id) === 3">
                      <strong><span class="text-secondary">{{ datetime_start(campaign.id) }}</span></strong> -
                      <strong><span class="text-secondary">{{ datetime_end(campaign.id) }}</span></strong>
                    </span>
                      <span v-else>test</span>
                      <font-awesome-icon :icon="['far', 'address-card']" class="ml-3 mr-1" />
                      {{ campaign.project_organization }}
                    </small>
                  </div>
                </b-dropdown-item-button>
                <b-dropdown-divider v-if="index < Object.keys(menuCampaigns).length - 1"></b-dropdown-divider>
              </b-dropdown-group>
            </b-dropdown>
            <a :href="project_url" target="_blank" v-if="project_url !== ''" class="ml-3 mr-2" title="Open campaign website">
              Website <font-awesome-icon :icon="['fas', 'external-link-alt']" size="xs" class="align-baseline" />
            </a>
            <a :href="project_twitter_url" target="_blank" v-if="project_twitter_url !== ''" style="color: #55acee;" class="ml-2 d-none d-sm-inline" :title="'Open ' + short_name + ' on Twitter'">
              <img src="beluga-web/static/logos/x_logo.svg" alt="X logo" style="margin-bottom: 3px; height: 26px" />
            </a>
            <a :href="project_instagram_url" target="_blank" v-if="project_instagram_url !== ''" style="color: #ac2bac;" class="ml-2 d-none d-sm-inline" :title="'Open ' + short_name + ' on Instagram'">
              <font-awesome-icon :icon="['fab', 'instagram']" size="2x" />
            </a>
            <a :href="project_facebook_url" target="_blank" v-if="project_facebook_url !== ''" style="color: #3b5998;" class="ml-2 d-none d-sm-inline" :title="'Open ' + short_name + ' on Facebook'">
              <font-awesome-icon :icon="['fab', 'facebook']" size="2x" />
            </a>
            <a :href="project_youtube_url" target="_blank" v-if="project_youtube_url !== ''" style="color: #ed302f;" class="ml-2 d-none d-sm-inline" :title="'Open ' + short_name + ' on Youtube'">
              <font-awesome-icon :icon="['fab', 'youtube']" size="2x" />
            </a>
          </b-form>
        </b-col>
        <b-col xl="7" xxl="8" lg="6" sm="6" md="6" class="text-right my-auto text-muted d-none d-lg-inline-block">
        <span :class="campaignTypeClass" class="d-none d-xxl-inline-block">
          <strong>{{ campaignTypeLabel }} &middot;</strong>
        </span>
          <span v-if="cruise !== ''">
          Cruise: <strong><span class="text-dark">{{ cruise }}</span> &middot;</strong>
        </span>
          Organization: <strong><span class="text-dark">{{ project_organization }}</span> &middot; </strong>
          <span v-if="project_head !== ''">Chief scientist: <strong><span class="text-dark">{{ project_head }}</span> &middot; </strong></span>
          Start: <strong><span :class="datetime_start_class(this.selectedCampaign)">{{ datetime_start(this.selectedCampaign) }}</span></strong>
          <span v-if="datetime_end(this.selectedCampaign) !== ''">
          <strong> &middot;</strong>
          End: <strong><span :class="datetime_end_class(this.selectedCampaign)">{{ datetime_end(this.selectedCampaign) }}</span></strong>
        </span>
          <b-button v-if="project_feed !== ''" :variant="toggleFeedButtonClass" class="btn-sm ml-3" style="width: 90px;" @click="toggleFeedBar">
            {{ toggleFeedButtonLabel }} feed
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div v-if="message !== ''" class="alert alert-info p-2 m-0 text-center border-bottom-info rounded-0">
      <font-awesome-icon :icon="['fas', 'rss']" class="mr-2"></font-awesome-icon>
      <span v-html="message"></span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import moment from 'moment'
import Helpers from '@/mixins/helpers'

export default {
  name: 'CampaignBar',
  mixins: [
    Helpers
  ],
  created () {
    // Subscribe to store mutations
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'select_campaign') {
        // Set feed visibility according to campaign setting
        this.set_collapse({
          component: 'sidebar-feed',
          value: (Number(this.campaignSelected.option_feed) === 1 && this.campaignSelected.project_feed !== '')
        })
      }
    })
  },
  beforeDestroy () {
    // Unsubscribe from mutations
    this.unsubscribe()
  },
  methods: {
    ...mapMutations(['toggle_collapse', 'select_campaign', 'set_collapse']),
    toggleFeedBar: function () {
      this.toggle_collapse('sidebar-feed')
    }
  },
  computed: {
    ...mapState(['campaigns', 'selectedCampaign', 'collapseStates']),
    ...mapGetters(['campaignSelected', 'campaignType', 'campaign']),
    toggleFeedButtonLabel: function () {
      if (this.collapseStates['sidebar-feed']) {
        return 'Close'
      }
      return 'Open'
    },
    toggleFeedButtonClass: function () {
      if (this.collapseStates['sidebar-feed']) {
        return 'secondary'
      }
      return 'info'
    },
    currentCampaign: {
      get () {
        return this.selectedCampaign
      },
      set (campaignId) {
        if (this.selectedCampaign !== campaignId) {
          this.select_campaign(campaignId)
        }
      }
    },
    menuCampaignSelected: function () {
      if (this.selectedCampaign > 0) {
        if (this.campaignSelected.short_name !== '') {
          return this.campaignSelected.short_name + ' '
        }
        return this.campaignSelected.name + ' '
      }
      return 'Please select campaign'
    },
    menuCampaigns: function () {
      const groups = []
      const upcoming = []
      const active = []
      const completed = []
      for (const campaignId in this.campaigns) {
        const campaign = this.campaigns[campaignId]
        switch (this.campaignType(campaignId)) {
          // option.disabled = true
          case 1:
            active.push(campaign)
            break
          case 2:
            upcoming.push(campaign)
            break
          case 3:
            completed.push(campaign)
            break
          default:
        }
      }
      groups.push({ id: 'inprogress', label: 'In Progress', campaigns: active.sort(this.compareTimestamps) })
      groups.push({ id: 'upcoming', label: 'Upcoming', campaigns: upcoming.sort(this.compareTimestamps) })
      groups.push({ id: 'completed', label: 'Completed', campaigns: completed.sort(this.compareTimestamps) })
      return groups
    },
    short_name: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.short_name
      }
      return '-'
    },
    message: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.message
      }
      return ''
    },
    cruise: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.cruise
      }
      return '-'
    },
    project_organization: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_organization
      }
      return ''
    },
    project_head: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_head
      }
      return '-'
    },
    project_feed: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_feed
      }
      return ''
    },
    project_url: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_url
      }
      return ''
    },
    project_twitter_url: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_twitter_url
      }
      return ''
    },
    project_facebook_url: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_facebook_url
      }
      return ''
    },
    project_instagram_url: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_instagram_url
      }
      return ''
    },
    project_youtube_url: function () {
      if (this.selectedCampaign > 0) {
        return this.campaignSelected.project_youtube_url
      }
      return ''
    },
    datetime_start: function () {
      return (campaignId) => {
        if (campaignId > 0) {
          return moment.unix(this.campaign(campaignId).timestamp_start).format('MMM DD YYYY')
        }
        return '-'
      }
    },
    datetime_start_class: function () {
      return (campaignId) => {
        if (campaignId > 0) {
          if (Number(this.campaign(campaignId).timestamp_start) > (Date.now() / 1000)) {
            return 'text-primary'
          }
        }
        return 'text-dark'
      }
    },
    datetime_end: function () {
      return (campaignId) => {
        if (campaignId > 0) {
          if (Number(this.campaign(campaignId).timestamp_end) !== 0) {
            return moment.unix(this.campaign(campaignId).timestamp_end).format('MMM DD YYYY')
          } else if (Number(this.campaign(campaignId).timestamp_start) > (Date.now() / 1000)) {
            return ''
          }
        }
        return ''
      }
    },
    datetime_end_class: function () {
      return (campaignId) => {
        if (campaignId > 0) {
          if (Number(this.campaign(campaignId).timestamp_end) === 0) {
            return 'text-info'
          }
        }
        return 'text-dark'
      }
    },
    campaignTypeClass: function () {
      if (this.selectedCampaign > 0) {
        switch (Number(this.campaignType(this.selectedCampaign))) {
          case 1:
            return 'campaign-type-label-success'
          case 2:
            return 'campaign-type-label-primary'
          default:
            return 'campaign-type-label-secondary'
        }
      }
      return ''
    },
    campaignTypeLabel: function () {
      if (this.selectedCampaign > 0) {
        switch (this.campaignType(this.selectedCampaign)) {
          case 1:
            return 'In Progress'
          case 2:
            return 'Upcoming'
          default:
            return 'Completed'
        }
      }
      return 'Unknown'
    }
  }
}
</script>

<style lang="scss">

  .campaign-bar {
    z-index: 10;
  }

  .campaign-type-label {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
  }
  .campaign-type-label-primary {
    color: #007bff;
    background-color: transparent;
    border-color: #007bff;
  }
  .campaign-type-label-success {
    color: #28a745;
    background-color: transparent;
    border-color: #28a745;
  }
  .campaign-type-label-secondary {
    color: #6c757d;
    background-color: transparent;
    border-color: #212529;
  }

  .campaign-dropdown > .btn {
    text-align: left;
    background-color: #ffffff;
    color: #212529;
    border-color: rgba(0, 0, 0, 0.125);
  }

  .campaign-dropdown > ul {
    z-index: 2000;
    height: auto;
    max-height: 610px;
    overflow-y: auto;
  }
  .campaign-dropdown > ul > li {
    width: 450px;
  }
  .dropdown-item > div {
    white-space: normal;
  }
  /*.header-upcoming {*/
  /*  background-color: rgba(0, 123, 255, 0.025);*/
  /*}*/
  .header-upcoming > header {
    color: #007bff;
    font-weight: bold;
  }
  /*.header-inprogress {*/
  /*  background-color: rgba(40, 167, 69, 0.025);*/
  /*}*/
  .header-inprogress > header {
    color: #28a745;
    font-weight: bold;
  }
  /*.header-completed {*/
  /*  background-color: rgba(108, 117, 125, 0.025);*/
  /*}*/
  .header-completed > header {
    color: #6c757d;
    font-weight: bold;
  }

  /*.border-bottom-info {
    border-bottom: 1px solid #bee5eb;
  }*/

</style>
